import { render } from "./SkillView.vue?vue&type=template&id=28f86d62&scoped=true"
import script from "./SkillView.vue?vue&type=script&lang=js"
export * from "./SkillView.vue?vue&type=script&lang=js"

import "./SkillView.vue?vue&type=style&index=0&id=28f86d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f86d62"]])

export default __exports__